module.exports = __webpack_public_path__ + "img/solution-preevision2x-intro.9eee398b.png";